"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitApiUpdateQuestion = exports.updateQuestionAnswers = exports.updateQuestion = exports.updateLastReorderedQuestion = exports.reorderPreviewQuestions = exports.reorderFormQuestions = exports.loadQuestions = exports.deleteQuestion = exports.cloneQuestion = exports.addQuestion = exports.UPDATE_QUESTION_POSITIONS = exports.UPDATE_QUESTION_LOAD = exports.UPDATE_QUESTION_ERROR = exports.UPDATE_QUESTION = exports.REORDER_QUESTIONS_ERROR = exports.REORDER_LAST_QUESTION = exports.NEW_QUESTION_LOAD = exports.NEW_QUESTION_ERROR = exports.NEW_QUESTION = exports.LOAD_QUESTIONS_SUCCESS = exports.LOAD_QUESTIONS_ERROR = exports.LOAD_QUESTION = exports.DELETE_QUESTION_LOAD = exports.DELETE_QUESTION_ERROR = exports.DELETE_QUESTION = exports.CLONE_QUESTION_LOAD = exports.CLONE_QUESTION = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _utils = _interopRequireDefault(require("../../config/utils"));

var _excluded = ["created_at", "updated_at", "answers", "options", "question_type_translated", "fast_track", "choice_options_attributes", "choice_ids", "is_multi_checkbox"];
/* eslint-disable camelcase */

if (!window.pdfFormConfigObject) {
  (0, _utils["default"])();
}

var LOAD_QUESTION = exports.LOAD_QUESTION = 'LOAD_QUESTION';
var LOAD_QUESTIONS_SUCCESS = exports.LOAD_QUESTIONS_SUCCESS = 'LOAD_QUESTIONS_SUCCESS';
var LOAD_QUESTIONS_ERROR = exports.LOAD_QUESTIONS_ERROR = 'LOAD_QUESTIONS_ERROR';
var apiUrl = window.pdfFormConfigObject.api_url;
var xcrsf = window.pdfFormConfigObject.csrf;
var environment = window.pdfFormConfigObject.environment;
var PRODUCTION_HEADERS = {
  'X-CSRF-Token': xcrsf,
  'x-requested-with': 'XMLHttpRequest',
  accept: 'application/json, text/javascript, */*; q=0.01',
  'content-type': 'application/json'
};
var DEVELOPMENT_HEADERS = {
  'X-User-Email': 'pernix@careerplug.com',
  'X-User-Token': '1QiZ8aGJibRcZRqbspT4',
  'x-requested-with': 'XMLHttpRequest',
  accept: 'application/json, text/javascript, */*; q=0.01',
  'content-type': 'application/json'
}; // Strip out unpermitted parameters before sending to API

var stripUnpermittedParams = function stripUnpermittedParams(question) {
  var created_at = question.created_at,
      updated_at = question.updated_at,
      answers = question.answers,
      options = question.options,
      question_type_translated = question.question_type_translated,
      fast_track = question.fast_track,
      choice_options_attributes = question.choice_options_attributes,
      choice_ids = question.choice_ids,
      is_multi_checkbox = question.is_multi_checkbox,
      permittedQuestion = (0, _objectWithoutPropertiesLoose2["default"])(question, _excluded);
  return permittedQuestion;
};

var loadQuestions = exports.loadQuestions = function loadQuestions(questionURL) {
  var fetchLoad = function fetchLoad() {
    return {
      type: LOAD_QUESTION,
      payload: true
    };
  };

  var fetchSuccess = function fetchSuccess(questions) {
    return {
      type: LOAD_QUESTIONS_SUCCESS,
      payload: questions
    };
  };

  var fetchError = function fetchError(errorMsg) {
    return {
      type: LOAD_QUESTIONS_ERROR,
      payload: errorMsg
    };
  };

  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(dispatch) {
        var response, data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch(fetchLoad());
                _context.prev = 1;
                _context.next = 4;
                return fetch("" + apiUrl + questionURL, {
                  method: 'GET',
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;
                dispatch(fetchSuccess(data));
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                dispatch(fetchError(_context.t0));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var NEW_QUESTION = exports.NEW_QUESTION = 'NEW_QUESTION';
var NEW_QUESTION_ERROR = exports.NEW_QUESTION_ERROR = 'NEW_QUESTION_ERROR';

var errorOnQuestion = function errorOnQuestion(err) {
  return {
    type: NEW_QUESTION_ERROR,
    payload: err
  };
};

var NEW_QUESTION_LOAD = exports.NEW_QUESTION_LOAD = 'NEW_QUESTION_LOAD';

var addQuestion = exports.addQuestion = function addQuestion(question, lastSave) {
  var newQuestionLoad = function newQuestionLoad() {
    return {
      type: NEW_QUESTION_LOAD,
      payload: true
    };
  };

  var saveQuestion = function saveQuestion(quest) {
    return {
      type: NEW_QUESTION,
      payload: quest,
      latestAddedQuestion: quest,
      lastSavePayload: lastSave
    };
  };

  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(dispatch) {
        var strippedQuestion, response, data;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch(newQuestionLoad());
                _context2.prev = 1;
                strippedQuestion = stripUnpermittedParams(question);
                _context2.next = 5;
                return fetch(apiUrl + "/manage/questions", {
                  method: 'POST',
                  body: JSON.stringify({
                    question: strippedQuestion
                  }),
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 5:
                response = _context2.sent;
                _context2.next = 8;
                return response.json();

              case 8:
                data = _context2.sent;
                dispatch(saveQuestion(data));
                return _context2.abrupt("return", data);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](1);
                dispatch(errorOnQuestion(_context2.t0));
                return _context2.abrupt("return", null);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 13]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

var UPDATE_QUESTION = exports.UPDATE_QUESTION = 'UPDATE_QUESTION';
var UPDATE_QUESTION_LOAD = exports.UPDATE_QUESTION_LOAD = 'UPDATE_QUESTION_LOAD';
var UPDATE_QUESTION_ERROR = exports.UPDATE_QUESTION_ERROR = 'UPDATE_QUESTION_ERROR';

var updateQuestion = exports.updateQuestion = function updateQuestion(question, lastSave) {
  var updateLoad = function updateLoad() {
    return {
      type: UPDATE_QUESTION_LOAD,
      payload: true
    };
  };

  var updateState = function updateState(quest) {
    return {
      type: UPDATE_QUESTION,
      payload: quest,
      lastSavePayload: lastSave
    };
  };

  var updateError = function updateError(err) {
    return {
      type: UPDATE_QUESTION_ERROR,
      payload: err
    };
  };

  return function (dispatch) {
    dispatch(updateLoad());

    try {
      // First update the local state with what we have
      dispatch(updateState(question));
      var strippedQuestion = stripUnpermittedParams(question);
      fetch(apiUrl + "/manage/questions/" + question.id, {
        method: 'PUT',
        body: JSON.stringify({
          question: strippedQuestion
        }),
        headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        // IMPORTANT: Update the Redux state with the response from the API
        // This ensures we have proper IDs for all answers
        dispatch(updateState(data));
      })["catch"](function (error) {
        // DEBUG: Log API errors
        // eslint-disable-next-line no-console
        console.error('UPDATE QUESTION - API Error:', error);
      });
    } catch (error) {
      dispatch(updateError(error)); // DEBUG: Log action errors
      // eslint-disable-next-line no-console

      console.error('UPDATE QUESTION - Action Error:', error);
    }
  };
};

var waitApiUpdateQuestion = exports.waitApiUpdateQuestion = function waitApiUpdateQuestion(question, lastSave) {
  var updateLoad = function updateLoad() {
    return {
      type: UPDATE_QUESTION_LOAD,
      payload: true
    };
  };

  var updateState = function updateState(quest) {
    return {
      type: UPDATE_QUESTION,
      payload: quest,
      lastSavePayload: lastSave
    };
  };

  var updateError = function updateError(err) {
    return {
      type: UPDATE_QUESTION_ERROR,
      payload: err
    };
  };

  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(dispatch) {
        var strippedQuestion, response, data;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch(updateLoad());
                _context3.prev = 1;
                strippedQuestion = stripUnpermittedParams(question);
                _context3.next = 5;
                return fetch(apiUrl + "/manage/questions/" + question.id, {
                  method: 'PUT',
                  body: JSON.stringify({
                    question: strippedQuestion
                  }),
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 5:
                response = _context3.sent;
                _context3.next = 8;
                return response.json();

              case 8:
                data = _context3.sent; // Make sure we update the Redux state with the full API response
                // This ensures answer IDs are properly tracked

                dispatch(updateState(data));
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](1);
                dispatch(updateError(_context3.t0)); // DEBUG: Log any errors
                // eslint-disable-next-line no-console

                console.error('WAIT API UPDATE QUESTION - Error:', _context3.t0);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 12]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

var updateQuestionAnswers = exports.updateQuestionAnswers = function updateQuestionAnswers(apiQuestion, localQuestion, lastSave) {
  var updateLoad = function updateLoad() {
    return {
      type: UPDATE_QUESTION_LOAD,
      payload: true
    };
  };

  var updateState = function updateState(quest) {
    return {
      type: UPDATE_QUESTION,
      payload: quest,
      lastSavePayload: lastSave
    };
  };

  var updateError = function updateError(err) {
    return {
      type: UPDATE_QUESTION_ERROR,
      payload: err
    };
  };

  return function (dispatch) {
    dispatch(updateLoad());

    try {
      // First update the UI with the local state
      dispatch(updateState(localQuestion));
      var strippedQuestion = stripUnpermittedParams(apiQuestion);
      fetch(apiUrl + "/manage/questions/" + apiQuestion.id, {
        method: 'PUT',
        body: JSON.stringify({
          question: strippedQuestion
        }),
        headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        // Update state with API response to ensure IDs are properly preserved
        dispatch(updateState(data));
      })["catch"](function (error) {
        // eslint-disable-next-line no-console
        console.error('UPDATE QUESTION ANSWERS - Error:', error);
      });
    } catch (error) {
      dispatch(updateError(error)); // eslint-disable-next-line no-console

      console.error('UPDATE QUESTION ANSWERS - Action Error:', error);
    }
  };
};

var DELETE_QUESTION_ERROR = exports.DELETE_QUESTION_ERROR = 'DELETE_QUESTION_ERROR';
var DELETE_QUESTION = exports.DELETE_QUESTION = 'DELETE_QUESTION';
var DELETE_QUESTION_LOAD = exports.DELETE_QUESTION_LOAD = 'DELETE_QUESTION_LOAD';

var deleteQuestion = exports.deleteQuestion = function deleteQuestion(question, lastSave) {
  var deleteLoad = function deleteLoad() {
    return {
      type: DELETE_QUESTION_LOAD,
      payload: true
    };
  };

  var deleteQuestionFromRedux = function deleteQuestionFromRedux(quest) {
    return {
      type: DELETE_QUESTION,
      payload: quest,
      lastSavePayload: lastSave
    };
  };

  var errorOnDeleteQuestion = function errorOnDeleteQuestion(err) {
    return {
      type: DELETE_QUESTION_ERROR,
      payload: err
    };
  };

  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(dispatch) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch(deleteLoad());
                _context4.prev = 1;
                dispatch(deleteQuestionFromRedux(question));
                _context4.next = 5;
                return fetch(apiUrl + "/manage/questions/" + question.id, {
                  method: 'DELETE',
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 5:
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);
                dispatch(errorOnDeleteQuestion(_context4.t0));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 7]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

var REORDER_QUESTIONS_ERROR = exports.REORDER_QUESTIONS_ERROR = 'REORDER_QUESTIONS_ERROR';

var reorderError = function reorderError(err) {
  return {
    type: REORDER_QUESTIONS_ERROR,
    payload: err
  };
};

var UPDATE_QUESTION_POSITIONS = exports.UPDATE_QUESTION_POSITIONS = 'UPDATE_QUESTION_POSITIONS';

var updateQuestionPositions = function updateQuestionPositions(questions) {
  return {
    type: UPDATE_QUESTION_POSITIONS,
    payload: questions
  };
};

var REORDER_LAST_QUESTION = exports.REORDER_LAST_QUESTION = 'REORDER_LAST_QUESTION';

var updateLastReorderedQuestion = exports.updateLastReorderedQuestion = function updateLastReorderedQuestion(questionId) {
  return {
    type: REORDER_LAST_QUESTION,
    payload: questionId
  };
};

var reorderPreviewQuestions = exports.reorderPreviewQuestions = function reorderPreviewQuestions(questionSet, questionSetState) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee5(dispatch) {
        var updatedQuestions;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetch(apiUrl + "/manage/questions/sort", {
                  method: 'POST',
                  body: JSON.stringify(questionSet),
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 3:
                // don't do this!! See below!!
                updatedQuestions = questionSetState.map(function (question) {
                  return (0, _extends2["default"])({}, question, {
                    position: questionSet.question.indexOf(question.id) + 1
                  });
                });
                updatedQuestions.sort(function (a, b) {
                  return a.position - b.position;
                });
                dispatch(updateQuestionPositions(updatedQuestions));
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                dispatch(reorderError(_context5.t0));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 8]]);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}; // note that unlike the example above, we're only posting the questions that had their positions updated - NOT all questions.


var reorderFormQuestions = exports.reorderFormQuestions = function reorderFormQuestions(updatedQuestions, movedQuestionId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee6(dispatch) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return fetch(apiUrl + "/manage/questions/reorder", {
                  method: 'POST',
                  body: JSON.stringify({
                    questions: updatedQuestions,
                    question_set_id: updatedQuestions[0].question_set_id
                  }),
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 3:
                // it's better to reload from DB than to assume our changes were made (as the old version did...)
                // so dispatch a fetch request to pull the re-ordered questions from DB and force the re-render
                dispatch(loadQuestions(window.pdfFormConfigObject.form_questions_url)).then(function () {
                  return dispatch(updateLastReorderedQuestion(movedQuestionId));
                });
                _context6.next = 9;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                dispatch(reorderError(_context6.t0));

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 6]]);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};

var CLONE_QUESTION = exports.CLONE_QUESTION = 'CLONE_QUESTION';
var CLONE_QUESTION_LOAD = exports.CLONE_QUESTION_LOAD = 'CLONE_QUESTION_LOAD';

var cloneQuestionLoad = function cloneQuestionLoad() {
  return {
    type: CLONE_QUESTION_LOAD,
    payload: true
  };
};

var cloneFormQuestion = function cloneFormQuestion(quest, lastSave) {
  return {
    type: CLONE_QUESTION,
    payload: quest,
    latestAddedQuestion: quest,
    lastSavePayload: lastSave
  };
};

var cloneQuestion = exports.cloneQuestion = function cloneQuestion(question, lastSave) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee7(dispatch) {
        var strippedQuestion, response, data;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                dispatch(cloneQuestionLoad());
                _context7.prev = 1;
                strippedQuestion = stripUnpermittedParams(question);
                _context7.next = 5;
                return fetch(apiUrl + "/manage/questions/clone_form_question", {
                  method: 'POST',
                  body: JSON.stringify({
                    question: strippedQuestion,
                    question_set_id: question.question_set_id,
                    page: question.data.page
                  }),
                  headers: environment === 'development' ? DEVELOPMENT_HEADERS : PRODUCTION_HEADERS
                });

              case 5:
                response = _context7.sent;
                _context7.next = 8;
                return response.json();

              case 8:
                data = _context7.sent;
                dispatch(loadQuestions(window.pdfFormConfigObject.form_questions_url)).then(function () {
                  return dispatch(cloneFormQuestion(data, lastSave));
                });
                _context7.next = 15;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](1); // since this is adding a question, we'll reuse that workflow

                dispatch(errorOnQuestion(_context7.t0));

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 12]]);
      }));

      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};